import { render, staticRenderFns } from "./InvoiceApproval.vue?vue&type=template&id=7135eacf&"
import script from "./InvoiceApproval.vue?vue&type=script&lang=js&"
export * from "./InvoiceApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports